import ButtonsFixed from './ButtonsFixed'

export * from './ButtonsFixed'

export default ButtonsFixed
